import { BufferWindowMemory } from "langchain/memory";
import getuser from "../aws_utils/getAuthuser";
import { addProjectChat } from "../apigateway/mongocalls";
import { invokeDummyAgentApi } from "../apigateway/agentcalls";
// import { gateleakConnect } from "apigateway/websocketcall";


const dummyagent = async (query, projectname, projectconversation) => {

    if(projectname === "" || projectname === undefined){
        alert("Select or Start New Project!")
        return
    }


let userid = ""
try {
    const user = await getuser()
    userid = user.username
} catch (error) {
    console.log(error)
}



 // Buffer Window Memory
 const memory = new BufferWindowMemory();

 // Attempts to add memery
//   const userchat = await getProjectChats(projectname)
  if(projectconversation.length === 0){
    //   console.log("No User Chats!")
      } else {
      
    //   console.log("User Chats Exist!")
      projectconversation.forEach(async item => {
          // console.log("Query", item.query)
          // console.log("Response", item.response)
          
          if(item.query === null){
          await memory.saveContext(
              {input: "..."},
              {output: item.response}
          )
          return
          }
  
          if(item.response === null){
              // console.log("2")
          await memory.saveContext(
              {input: item.query},
              {output: "..."},
              )
              return
          }
  
          await memory.saveContext(
              {input: item.query},
              {output: item.response},
          )
  
          });
      }
  
//   console.log("Conversation Memory", memory)

//   const history = await memory.loadMemoryVariables({});
  const messages = await memory.chatHistory.getMessages();
   const basemessages = memory.chatHistory.messages

//   console.log("history", history.history)
//   console.log("Messages", messages)
 

  const serializeChatHistory = async (chatHistory) => {
      let aiCount = 0;
      let humanCount = 0;
      const serializedMessages = chatHistory.map((chatMessage) => {
          if (chatMessage._getType() === "human" && humanCount < 5) {
              humanCount++;
              return `Human: ${chatMessage.content}`;
          } else if (chatMessage._getType() === "ai" && aiCount < 5) {
              aiCount++;
              return `Assistant: ${chatMessage.content}`;
          } else {
              return null;
          }
      }).filter(message => message !== null);
      return serializedMessages;
  }
//   .join("\n")
  

    const oldmem = await serializeChatHistory(messages)
    const recentmem = await serializeChatHistory(basemessages.reverse());
    // console.log("Newmem", newmem)
    // console.log('Last 4 chats in Project...', oldmem); 
    // console.log('First 4 chats in Project...', recentmem);
    const sumupmemory = { 
        "____OLDEST CHAT HISTORY____": oldmem,
        "____MOST RECENT CHAT HISTORY____": recentmem.reverse(),   
    }
    // Not currently passing memory
    const memorysummary = JSON.stringify(sumupmemory)
//   console.log(memorysummary)



     // Invoke dummyagent websocket
   
    // let isReady = false
    // let connection 


    //   const connect = await gateleakConnect();
    //   console.log("websocket connection...", connect)
    //   connect.onopen = () => isReady = true
    //   connect.onclose = () => isReady = false

    //   connection = connect
    // console.log('isReady?', isReady);
    // console.log('ready state?', connection.readyState);
    // console.log('websock open variable is', WebSocket.OPEN);
    // if(isReady){
          
    //     if(connection.readyState === WebSocket.OPEN){
    //         console.log('websocket is open send message!')
    //     // console.log("current ws", ws.current);
    //     connection.send(JSON.stringify({
    //       action: 'dummyagent',
    //       payload: {
    //         query,
    //         memory: memorysummary,
    //     },
    // }))
    //     }
    //   }

    // if(!isReady){
    //     console.log('isReady is', isReady);
    //     console.log('ready state? of connection is', connection.readyState);
    //     // console.log('websocket closed variable is', WebSocket.CLOSED);
    //      if(connection.readyState === WebSocket.CLOSED){
    //       console.log('socket closed...')
    //      }
    // }

    // // Listen for messages

    // connection.onmessage = (event) => {
    // console.log("Message from gateleak server", event.data);    
    // }
   

    // The Lambda Invoke
    // const response = await invokedummyagent(query, "");

    // The Api Invoke
    const response = await invokeDummyAgentApi(query, memorysummary)
    // const parseresponse = JSON.parse(response)
    // console.log(response, parseresponse.body)
    let finalresp
   
    if(response === `error`){
        finalresp = `Request Timed Out... Try query again`
    }
    if(response === null || response === undefined || response === ''){
        finalresp = `Try rephrasing or simiplifying your query!`  
    } 
    if(response === `Agent stopped due to max iterations.`){
        finalresp = `Try rephrasing or simiplifying your query!`
    } 
    if(response !== null && response !== `error` && response !== `Agent stopped due to max iterations.`){
        finalresp = response
    }

  
    const addChatPackage = {
        "project": projectname,
        "userId": userid,
        "query": query,
        "response" : finalresp,   
        "agent" : "dummy agent" 
    }

    await addProjectChat(addChatPackage);

    // const output = {
    // "result": result,
    // "response": finalresp,
    // }

    return true

}

export default dummyagent

